import { useParams } from "react-router-dom";
import { BookingTracker } from "../components/BookingTracker";
import { useTranslation } from "react-i18next";

export const BookingTrackerPage = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  if (!id) {
    return <div>{t("bookings.bookingIdNotFound")}</div>;
  }

  return <BookingTracker bookingId={id} />;
};
